import { css } from 'styled-components';

const DEFAULT_MARGIN = '0.75rem';

export const BUTTON_STYLES = css`
  display: block;
  width: fit-content;
  text-transform: uppercase;
  font-size: 0.75rem;
  padding: 0.5rem 0.5rem;
  margin-top: ${(props) => (props.addTopMargin ? DEFAULT_MARGIN : '')};
  margin-right: ${(props) => (props.addRightMargin ? DEFAULT_MARGIN : '')};
`;
